
export enum OpeningClosingHoursType{
    APPOINTMENTS = "APPOINTMENTS", 
    CUSTOM = "CUSTOM", 
    STANDARD = "STANDARD"
}

export class OpeningClosingHoursRequest{
    friEFrom: string = "";
    friETo: string = "";
    friMFrom: string = "";
    friMTo: string = "";
    monEFrom: string = "";
    monETo: string = "";
    monMFrom: string = "";
    monMTo: string = "";
    satEFrom: string = "";
    satETo: string = "";
    satMFrom: string = "";
    satMTo: string = "";
    storeId: number;
    sunEFrom: string = "";
    sunETo: string = "";
    sunMFrom: string = "";
    sunMTo: string = "";
    thuEFrom: string = "";
    thuETo: string = "";
    thuMFrom: string = "";
    thuMTo: string = "";
    tueEFrom: string = "";
    tueETo: string = "";
    tueMFrom: string = "";
    tueMTo: string = "";
    wedEFrom: string = "";
    wedETo: string = "";
    wedMFrom: string = "";
    wedMTo: string = "";
    type: OpeningClosingHoursType;
    note: string = "";
    
}

export class  OpeningClosingHoursRequestCreate extends OpeningClosingHoursRequest{
    constructor(){super();}
}

export class  OpeningClosingHoursRequestUpdate extends OpeningClosingHoursRequest{
    constructor(){super();}
}

export class  OpeningClosingHoursRequestSearch{
    pageNumber: number;
    pageSize: number;
    sortBy: string;
    storeId: number;
    type: OpeningClosingHoursType;
    
}